import {
  CLEAR_LANDMARK_LIST,
  CREATE_LANDMARK,
  CREATE_LANDMARK_FAILED,
  CREATE_LANDMARK_SUCCESS,
  DELETE_LANDMARK,
  DELETE_LANDMARK_FAILED,
  DELETE_LANDMARK_SUCCESS,
  GET_LANDMARK_DETAILS,
  GET_LANDMARK_DETAILS_FAILED,
  GET_LANDMARK_DETAILS_SUCCESS,
  GET_LANDMARK_LIST,
  GET_LANDMARK_LIST_FAILED,
  GET_LANDMARK_LIST_SUCCESS,
  UPDATE_LANDMARK,
  UPDATE_LANDMARK_FAILED,
  UPDATE_LANDMARK_SUCCESS,
} from './actionTypes';

export const actionGetLandmarkList = (payload) => ({
  payload,
  type: GET_LANDMARK_LIST,
});

export const actionGetLandmarkListSuccess = (payload) => ({
  payload,
  type: GET_LANDMARK_LIST_SUCCESS,
});

export const actionGetLandmarkListFailed = (payload) => ({
  payload,
  type: GET_LANDMARK_LIST_FAILED,
});

export const actionGetLandmarkDetails = (payload) => ({
  payload,
  type: GET_LANDMARK_DETAILS,
});

export const actionGetLandmarkDetailsSuccess = (payload) => ({
  payload,
  type: GET_LANDMARK_DETAILS_SUCCESS,
});

export const actionGetLandmarkDetailsFailed = (payload) => ({
  payload,
  type: GET_LANDMARK_DETAILS_FAILED,
});

export const actionCreateLandmark = (payload) => ({
  payload,
  type: CREATE_LANDMARK,
});

export const actionCreateLandmarkSuccess = (payload) => ({
  payload,
  type: CREATE_LANDMARK_SUCCESS,
});

export const actionCreateLandmarkFailed = (payload) => ({
  payload,
  type: CREATE_LANDMARK_FAILED,
});

export const actionUpdateLandmark = (payload) => ({
  payload,
  type: UPDATE_LANDMARK,
});

export const actionUpdateLandmarkSuccess = (payload) => ({
  payload,
  type: UPDATE_LANDMARK_SUCCESS,
});

export const actionUpdateLandmarkFailed = (payload) => ({
  payload,
  type: UPDATE_LANDMARK_FAILED,
});

export const actionDeleteLandmark = (payload) => ({
  payload,
  type: DELETE_LANDMARK,
});

export const actionDeleteLandmarkSuccess = (payload) => ({
  payload,
  type: DELETE_LANDMARK_SUCCESS,
});

export const actionDeleteLandmarkFailed = (payload) => ({
  payload,
  type: DELETE_LANDMARK_FAILED,
});

export const actionClearLandmarkList = () => ({
  type: CLEAR_LANDMARK_LIST,
});
